import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/information-ratio',
  component: () => import('../../routes/InformationRatio.svelte'),
  card: {
    id: 'information-ratio',
    title: 'Information Ratio Calculator',
    description: 'Measure active portfolio performance by calculating excess return per unit of tracking error relative to a benchmark.',
    icon: 'speed',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/information-ratio',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Information Ratio Calculator – Active Portfolio Performance',
    description: 'Free Information Ratio calculator. Measure how much active return your portfolio generates per unit of tracking error against a benchmark. Evaluate manager skill with this risk-adjusted performance metric.',
  },
};

export default meta;
